/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Conflict_Resolution18Inputs */

const en_job_form_enum_conflict_resolution18 = /** @type {(inputs: Job_Form_Enum_Conflict_Resolution18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflict Resolution`)
};

const de_job_form_enum_conflict_resolution18 = /** @type {(inputs: Job_Form_Enum_Conflict_Resolution18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfliktlösungsfähigkeit`)
};

/**
* | output |
* | --- |
* | "Conflict Resolution" |
*
* @param {Job_Form_Enum_Conflict_Resolution18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_conflict_resolution18 = /** @type {((inputs?: Job_Form_Enum_Conflict_Resolution18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Conflict_Resolution18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_conflict_resolution18(inputs)
	return en_job_form_enum_conflict_resolution18(inputs)
});
export { job_form_enum_conflict_resolution18 as "job_form_enum_CONFLICT_RESOLUTION" }